























import { Vue, Component } from "vue-property-decorator"
import Conversion from "@/components/BaseComponents/Conversion.vue"
import Calculator from "@/components/Calculator.vue"

const AppProps = Vue.extend({
	props: {}
})

@Component({
	components: {
		Conversion,
		Calculator
	}
})
export default class UnitConverter extends AppProps {
	calculatorFinished = false
	conversionReady = false
	combinations: ConversionObject[] = [
		{
			from: "fahrenheit",
			to: "celsius"
		},
		{
			from: "cups",
			to: "deciliter"
		},
		{
			from: "ounces",
			to: "gram"
		}
	]
}
